module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-1-e0c2a4f8201e160f0e7fa5f4db88024d.jpg";